import { api } from "../api";

// Własna, anonimowa analityka sklepu (panel admina → Analityka). Wysyła pojedyncze zdarzenia:
// wejście na stronę, obejrzenie produktu, dodanie do koszyka, wyszukiwanie.
// Sesja = losowy identyfikator żyjący do zamknięcia karty. Identyfikator odwiedzającego (do liczenia
// powracających) jest tworzony dopiero po zgodzie na cookies analityczne. Ruch z panelu admina i
// zalogowanego administratora jest pomijany, żeby nie zawyżał statystyk.

const SOURCES = [
  ["google", /google\./], ["facebook", /facebook\.|fb\.|fbclid/], ["instagram", /instagram\./], ["tiktok", /tiktok\./],
  ["youtube", /youtube\.|youtu\.be/], ["bing", /bing\./], ["ceneo", /ceneo\./], ["skąpiec", /skapiec\./],
  ["messenger / whatsapp", /messenger\.|whatsapp\.|wa\.me/], ["e-mail", /mail\.|poczta\.|outlook\./],
];

// Bez zgody na cookies analityczne nic nie zapisujemy w przeglądarce (art. 399 PKE) — sesja żyje tylko w pamięci strony.
let memSession = null;
const consented = () => { try { return localStorage.getItem("dl_cookie_consent") === "all"; } catch { return false; } };

const rnd = () => Math.random().toString(36).slice(2, 12) + Date.now().toString(36);

function session() {
  try {
    let s = consented() ? JSON.parse(sessionStorage.getItem("dl_an") || "null") : memSession;
    if (s) return s;
    const params = new URLSearchParams(window.location.search);
    let referrer = "";
    try { referrer = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch { /* zły adres */ }
    if (referrer === window.location.hostname.replace(/^www\./, "")) referrer = "";
    const utm = (params.get("utm_source") || "").toLowerCase();
    const probe = `${utm} ${referrer} ${params.has("fbclid") ? "fbclid" : ""} ${params.has("gclid") ? "google." : ""}`;
    let source = utm || (referrer ? "inne strony" : "bezpośrednie");
    for (const [name, rx] of SOURCES) if (rx.test(probe)) { source = name; break; }
    s = { id: rnd(), source, referrer, campaign: params.get("utm_campaign") || "" };
    if (consented()) sessionStorage.setItem("dl_an", JSON.stringify(s)); else memSession = s;
    return s;
  } catch { return null; }
}

function visitorId() {
  try {
    if (localStorage.getItem("dl_cookie_consent") !== "all") return "";
    let v = localStorage.getItem("dl_vid");
    if (!v) { v = rnd(); localStorage.setItem("dl_vid", v); }
    return v;
  } catch { return ""; }
}

const device = () => {
  const w = window.innerWidth;
  return w < 640 ? "telefon" : w < 1024 ? "tablet" : "komputer";
};

export function trackEvent(type, extra = {}) {
  try {
    if (window.location.pathname.startsWith("/admin") || localStorage.getItem("dl_admin_token")) return;
    const s = session();
    if (!s) return;
    api.post("/analytics/event", {
      type, path: window.location.pathname, session_id: s.id, visitor_id: visitorId(),
      source: s.source, referrer: s.referrer, campaign: s.campaign, device: device(), ...extra,
    }).catch(() => {});
  } catch { /* analityka nigdy nie może zepsuć strony */ }
}
